export class LoadingSpinner {
  static render(): string {
    return `
      <div class="loading">
        <div class="spinner"></div>
        Loading...
      </div>
    `;
  }
}
